import Vue from "vue";
import App from "./Index.vue";
import "@/pages/common.js";
import { validateInitUrlParams } from "@/utils/validateInitParams.js";
import { Lazyload } from "vant";
import { getOrgId, getToken } from "@/utils/common.js";
import { isHideIosFunctionality } from "@/utils/isTerminal.js";

// 如果有登录信息
if (getToken()) {
  // 如果没有机构信息，去'未加入机构'
  if (!getOrgId()) {
    window.location.href = "./uninvited.html";
  } else {
    if (isHideIosFunctionality) {
      window.location.href = "./mineExam.html";
    } else {
      Vue.use(Lazyload);
      if (validateInitUrlParams()) {
        //初始化完成 window.PAGE_PARAMS 和 window.PAGE_PATH 可用
        new Vue({
          render: h => h(App)
        }).$mount("#app");
      }
    }
  }
} else {
  // 未登录
  window.location.href = "./tourists.html";
}
